import { Avatar, Dropdown, Modal, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { CaretDownOutlined, UserOutlined } from "@ant-design/icons";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './index.css'
import ChangePassword from '../../Pages/changePassword';
import useAuthStore from '../../Store/authStore';
import useAuth from '../../Config/hooks/Apis/useAuth';
import { resolveMediaUrl } from '../../Config/api/baseUrl';

const HeaderDropDown = ({ showDrawer, setShowDrawer, drawer = true }) => {

    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuthStore();
    const { logout } = useAuth();

    const [itemIsActive, setItemIsActive] = useState('');
    const [changePasswordModal, setChangePasswordModal] = useState(false);

    const closeDrawerIfNeeded = () => {
        if (drawer && setShowDrawer) setShowDrawer(false);
    };

    const navItemNavigator = (item) => {
        if (item === 'Change Password') {
            setChangePasswordModal(true);
            closeDrawerIfNeeded();
            setItemIsActive(item);
            return;
        }

        const selectedItem = item?.replaceAll(' ', '');
        if (selectedItem) {
            navigate(`/${selectedItem}`);
        }
        setItemIsActive(item);
        closeDrawerIfNeeded();
    };

    const items = [
        {
            key: 'Profile',
            label: (
                <Link className={`header-profile-menu-label ${itemIsActive === 'Profile' ? 'is-active' : ''}`}>
                    Profile
                </Link>
            ),
            onClick: () => navItemNavigator('Profile'),
        },
        {
            key: 'My Order',
            label: (
                <Link className={`header-profile-menu-label ${itemIsActive === 'My Order' ? 'is-active' : ''}`}>
                    My order
                </Link>
            ),
            onClick: () => navItemNavigator('My Order'),
        },
        {
            key: 'Change Password',
            label: (
                <Link className={`header-profile-menu-label ${itemIsActive === 'Change Password' ? 'is-active' : ''}`}>
                    Change Password
                </Link>
            ),
            onClick: () => navItemNavigator('Change Password'),
        },
        { type: 'divider' },
        {
            key: 'Logout',
            label: (
                <Link className="header-profile-menu-label">
                    Logout
                </Link>
            ),
            onClick: async () => {
                try {
                    await logout();
                    navigate('/');
                    closeDrawerIfNeeded();
                } catch (error) {
                    console.error('Logout error:', error);
                }
            },
        },
    ];

    useEffect(() => {
        if (location.pathname !== '/') {
            const selectedItem = items.find((item) => item?.key && ('/' + String(item.key).replaceAll(' ', '') === location.pathname));
            setItemIsActive(selectedItem?.key || '');
        } else {
            setItemIsActive('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    const getUserImageUrl = () => {
        if (!user?.image) return null;
        if (user.image.startsWith('http')) return user.image;
        return resolveMediaUrl(user.image);
    };

    const userImageUrl = getUserImageUrl();
    const displayName = user?.firstName || user?.firstname || user?.name || 'Account';

    return (
        <>
            <Dropdown
                menu={{ items, selectable: true, selectedKeys: itemIsActive ? [itemIsActive] : [] }}
                trigger={['click']}
                placement="bottomRight"
                rootClassName="header-profile-dropdown"
            >
                <button
                    type="button"
                    className="header-profile-trigger"
                    aria-label="Account menu"
                >
                    <Avatar
                        size={28}
                        src={userImageUrl}
                        icon={!userImageUrl ? <UserOutlined /> : null}
                        className="shrink-0"
                        onError={() => false}
                    />
                    <span className="header-profile-trigger__name">{displayName}</span>
                    <CaretDownOutlined className="header-profile-trigger__caret" />
                </button>
            </Dropdown>

            {changePasswordModal && (
                <Modal
                    open={changePasswordModal}
                    onCancel={() => setChangePasswordModal(false)}
                    width={400}
                    centered
                    footer={false}
                >
                    <Row justify={'center'} className='flex flex-col items-center gap-4 px-4 w-full'>
                        <ChangePassword />
                    </Row>
                </Modal>
            )}
        </>
    )
}

export default HeaderDropDown
